/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Modals\ModalPark\ModalPark.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday January 17th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday January 17th 2024 9:50:50 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { FormEvent, Fragment, MouseEventHandler, useEffect, useState } from "react";
import MyModal from "Content/Modals/MyModal";
import {Form, Button} from "react-bootstrap";
import translator from "MultiLanguage/TranslationWrapper";
import Styles from "Content/Modals/ModalPartner/ModalPartner.module.css";
import LoadingScreen from "Content/LoadingScreen/LoadingScreen";
import ModalConfirmation from "Content/Modals/ModalConfirmation/ModalConfirmation";
import { TextField } from "@mui/material";
import { ParkUpdateType } from "Type/park.type";

type UpdatablePark = ParkUpdateType & {[x: string]: string | undefined};

type ModalProps = {
    show: boolean;
    onClose: MouseEventHandler<HTMLDivElement>;
    closeModal: MouseEventHandler;
    title: string;
    submitFunc: Function;
    data: UpdatablePark;
    ParkID?: string,
    updatePark?: Function,
};

function ModalPark(props: ModalProps) {
    const [name, setName] = useState(props.data.Name);
    const [address, setAddress] = useState(props.data.Address);
    const [postalCode, setPostalCode] = useState(props.data.PostalCode);
    const [city, setCity] = useState(props.data.City);
    const [state, setState] = useState(props.data.State);
    const [country, setCountry] = useState(props.data.Country);
    const [update, setUpdate] = useState({});
    const [spinner, setSpinner] = useState(false);
    const [isOkay, setIsOkay] = useState<boolean>(false);
    const [openModal, setOpenModal] = useState<boolean>(false);

    useEffect(() => {
        let tmp: UpdatablePark = {Name: name, Address: address, PostalCode: postalCode, City: city, State: state, Country: country};
        let tmpItems = Object.entries(tmp);
        if (props.ParkID) {
            let diff: UpdatablePark = {};
            for (let item of tmpItems)
                if (item[1] !== props.data[item[0]])
                    diff[item[0]] = item[1];

            if (Object.keys(diff).length > 0) {
                diff.id = props.ParkID;
                setUpdate(diff);
            } else {
                setUpdate({});
            }
        }
    }, [name, address, postalCode, city, state, country]);

    const HandleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsOkay(false);
        setSpinner(true);
        const afterCall = (isOkay: boolean = false) => {
            setIsOkay(isOkay);
            setOpenModal(true);
            setSpinner(false);
        };
        const data: ParkUpdateType = {
            Name: name,
            Address: address,
            PostalCode: postalCode,
            City: city,
            State: state,
            Country: country,
        };
        if (props.ParkID) {
            props.submitFunc(update).then(() => {
                setIsOkay(true);
                if (props.updatePark)
                    props.updatePark(data);
                afterCall(true);
            })
            .catch(() => {afterCall()});
        } else {
            props.submitFunc(data).then((res: any) => {
                setIsOkay(true);
                if (props.updatePark) {
                    data.id = res.data.id;
                    props.updatePark(data);
                }
                afterCall(true);
            })
            .catch(() => {afterCall()});
        }
        setOpenModal(true);
        setSpinner(false);
    };

    return(
        <Fragment>
            <MyModal closeModal={props.closeModal} show={props.show} addCloseCross={true} onClose={props.onClose} footer={(() => { return (<></>); })()} title={props.title} className={`${Styles.modal}`}>
                {
                    spinner ?
                        <div className={`${Styles.spinnerHolder}`}>
                            <LoadingScreen />
                        </div>
                        :null
                }
                <Form className={`${Styles.formHolder}`} onSubmit={HandleSubmit}>
                    <TextField label={translator.decode("dynamic.name")} onChange={(e) => setName(e.target.value)} value={name} />
                    <TextField label={translator.decode("dynamic.address")} onChange={(e) => setAddress(e.target.value)} value={address} />
                    <TextField label={translator.decode("dynamic.postalcode")} onChange={(e) => setPostalCode(e.target.value)} value={postalCode} />
                    <TextField label={translator.decode("dynamic.city")} onChange={(e) => setCity(e.target.value)} value={city} />
                    <TextField label={translator.decode("dynamic.state")} onChange={(e) => setState(e.target.value)} value={state} />
                    <TextField label={translator.decode("dynamic.country")} onChange={(e) => setCountry(e.target.value)} value={country} />
                    <Button disabled={!(city || postalCode)} className="mb-3" type="submit">{props.ParkID ? translator.decode("dynamic.modify") : translator.decode("dynamic.create")}</Button>
                </Form>
            </MyModal>
            <ModalConfirmation show={openModal} onClose={() => setOpenModal(false)} closeModal={() => setOpenModal(false)} isOkay={isOkay} />
        </Fragment>
    )
}

export default ModalPark;
